var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-page"},[_c('div',{staticClass:"row pb-5"},[_c('div',{staticClass:"col-12 col-lg-8 mx-auto mt-n4"},[_c('div',{staticClass:"bg-white shadow-sm p-5 position-relative"},[(!_vm.graphql_loaded)?_c('LoaderContent',{attrs:{"welcomeMessage":false,"alignSpinnerTop":true}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }